import React from "react";
import {Container} from "@mui/material";

const Mevzuat = () => {
    return (
        <Container maxWidth="lg" sx={{py: 5}}>
            <>
                <p
                    style={{
                        fontSize: 18,
                        fontFamily: '"Roboto Slab", Tahoma, Geneva, Verdana, sans-serif',
                        color: "#333333"
                    }}
                >
    <span style={{fontWeight: "bolder", color: "#1f497d"}}>
      ASGARİ ÜCRETİN NET HESABI VE İŞVERENE MALİYETİ
    </span>
                </p>
                <p>
    <span style={{fontSize: 12}}>
      Çalışma Genel Müdürlüğü / Çalışma İstatistikleri Daire Başkanlığı
      tarafından hazırlanmıştır.
    </span>
                </p>
                <p
                    style={{
                        fontSize: 18,
                        fontFamily: '"Roboto Slab", Tahoma, Geneva, Verdana, sans-serif',
                        color: "#333333"
                    }}
                >
    <span
        style={{
            fontSize: 12,
            fontWeight: "bolder",
            fontFamily: "arial, helvetica, sans-serif",
            color: "#004080"
        }}
    >
      01/01/2025&nbsp;- 31/12/2025
    </span>
                </p>
                <p>
    <span style={{fontWeight: "bolder"}}>
      ASGARİ ÜCRETİN NETİNİN HESABI (TL / AY)
    </span>
                </p>
                <table
                    border={0}
                    cellPadding={0}
                    cellSpacing={0}
                    style={{border: "none", width: 600}}
                >
                    <tbody>
                    <tr>
                        <td style={{padding: "10px 0px", width: 270}}>ASGARİ ÜCRET</td>
                        <td style={{padding: "10px 0px"}}>26,005.50</td>
                    </tr>
                    <tr>
                        <td style={{padding: "10px 0px"}}>SGK PRİMİ %14</td>
                        <td style={{padding: "10px 0px"}}>3,640.77</td>
                    </tr>
                    <tr>
                        <td style={{padding: "10px 0px"}}>İŞSİZLİK SİG. PRİMİ %1</td>
                        <td style={{padding: "10px 0px"}}>260.06</td>
                    </tr>
                    <tr>
                        <td style={{padding: "10px 0px"}}>KESİNTİLER TOPLAMI</td>
                        <td style={{padding: "10px 0px"}}>3,900.83</td>
                    </tr>
                    <tr>
                        <td style={{padding: "10px 0px"}}>
                            <span style={{fontWeight: "bolder"}}>NET ASGARİ ÜCRET</span>
                        </td>
                        <td style={{padding: "10px 0px"}}>22,104.67</td>
                    </tr>
                    </tbody>
                </table>
                <p
                    style={{
                        fontSize: 18,
                        fontFamily: '"Roboto Slab", Tahoma, Geneva, Verdana, sans-serif',
                        color: "#333333",
                        marginTop: 30
                    }}
                >
                    <span style={{fontWeight: "bolder"}}>İŞVERENE MALİYETİ (TL / AY)</span>
                </p>
                <table
                    border={0}
                    cellPadding={0}
                    cellSpacing={0}
                    style={{border: 0, width: 600}}
                >
                    <tbody>
                    <tr>
                        <td style={{padding: "10px 0px", width: 270}}>ASGARİ ÜCRET</td>
                        <td style={{padding: "10px 0px"}}>26,005.50</td>
                    </tr>
                    <tr>
                        <td style={{padding: "10px 0px"}}>
                            SGK PRİMİ %15.5 (İşveren Payı) (*)
                        </td>
                        <td style={{padding: "10px 0px"}}>4,095.87</td>
                    </tr>
                    <tr>
                        <td style={{padding: "10px 0px"}}>
                            İŞVEREN İŞSİZLİK SİGORTA PRİMİ %2
                        </td>
                        <td style={{padding: "10px 0px"}}>520.11</td>
                    </tr>
                    <tr>
                        <td style={{padding: "10px 0px"}}>
                            <span style={{fontWeight: "bolder"}}>İŞVERENE TOPLAM MALİYET</span>
                        </td>
                        <td style={{padding: "10px 0px"}}>30,621.48</td>
                    </tr>
                    </tbody>
                </table>
                <div
                    style={{
                        margin: "30px 0px 0px",
                        padding: "20px 5px 5px",
                        border: "1px dotted #333333",
                        fontSize: 14,
                        fontFamily: "arial, helvetica, sans-serif",
                        background: "#e9e9e9",
                        color: "#444444"
                    }}
                >
                    <p style={{margin: "0px 0px 20px 0px"}}>
                        Not: Gelir Vergisi ve Damga Vergisi hesaplanmamıştır.
                    </p>
                    <p style={{margin: "0px 0px 20px 0px"}}>
                        (*) 5510 sayılı Kanunun 81. maddesinin (ı) bendine göre, bentde belirtilen
                        şartları sağlayan işverenlere, SGK primi işveren payında 5 puanlık indirim
                        öngörüldüğünden hesaplamalar buna göre yapılmıştır. Gerekli şartları
                        sağlamayan işverenler için, SGK primi işveren payı %20,75'dir. 02.08.2024
                        tarihli ve 32620 sayılı Resmi Gazete'de yayımlanan 7524 sayılı " Vergi
                        Kanunları İle Bazı Kanunlarda ve 375 Sayılı Kanun Hükmünde Kararnamede
                        Değişiklik Yapılmasına Dair Kanun" un 28. maddesiyle; 5510 sayılı Sosyal
                        Sigortalar ve Genel Sağlık Sigortası Kanununun 81. maddesinin 1.
                        fıkrasının (c) bendinde yapılan değişiklikle, kısa vadeli sigorta kolları
                        (iş kazası ve meslek hastalıkları, hastalık ve analık) pirimi oranı %2'den
                        %2,25 e yükseltilmiştir.
                    </p>
                </div>
                <div
                    style={{
                        margin: "30px 0px 0px",
                        padding: 5,
                        border: "1px solid red",
                        fontWeight: "bold",
                        fontSize: 14,
                        fontFamily: "arial, helvetica, sans-serif",
                        background: "#e9e9e9",
                        color: "#444444"
                    }}
                >
                    HESAPLAMALAR BİLGİ İÇİNDİR. HİÇ BİR SORUMLULUK KABUL EDİLMEZ
                </div>
                <div
                    style={{
                        margin: "20px 0px",
                        padding: "0px 10px",
                        border: "1px solid #eee",
                        fontFamily: '"Roboto Slab", Tahoma, Geneva, Verdana, sans-serif',
                        color: "#333333"
                    }}
                >
                    <h4
                        style={{
                            margin: "10px 0px",
                            padding: 0,
                            fontWeight: 500,
                            fontSize: 14,
                            lineHeight: "1.2"
                        }}
                    >
                        <a
                            href="https://www.csgb.gov.tr/tr/poco-pages/asgari-ucret/"
                            target="_blank" rel="noreferrer"
                        >
                            Eski asgari ücret ve asgari ücret hesaplamaları için tıklayın
                        </a>
                    </h4>
                </div>
            </>
        </Container>
    );
};

export default Mevzuat;
